import Axios from "../config/Axios";

export const ApiCrearPeriodo = async (data) => {
  try {
    const result = await Axios.post(`/POSTcreatePeriodo`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiEditarPeriodo = async (data) => {
  try {
    const result = await Axios.post(`/POSTeditPeriodo`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiActivarDesactivarPeriodo = async (data) => {
  try {
    const result = await Axios.post(`/POSTtoggleEstadoPeriodo`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiDeletePeriodo = async (pre_periodo_id) => {
  try {
    const result = await Axios.post(`/POSTdeletePeriodo`, pre_periodo_id);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetAllPeriodos = async (data) => {
  try {
    const result = await Axios.get(`/GETallPeriodos`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetDataPeriodo = async (pre_periodo_id) => {
  try {
    const result = await Axios.get(`/GETdataPeriodo/${pre_periodo_id}`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetTodayPeriodo = async (data) => {
  try {
    const result = await Axios.get(`/GETtodayPeriodo`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
        code:"error"
      },
    ];
  }
};
